import React from 'react'

import './css/indicatorstatus.css'

const StatusIndicator = (props) => {
    const { indicator, className } = props;
    return (
        <div>
            <span className={className}></span> {indicator}
        </div>
    )
}

export default StatusIndicator